import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNotifications } from '~/contexts/NotificationContext';
import { sendChangeAccountName, sendChangeContactEmail } from '~/adapters/services/profiles/profile/tracking';
import { useOptionalAuthUser } from '~/contexts/Auth/AuthContext';
import { useAccountsRepository } from './rest';

export const personalAccountKey = 'personal-account';

export const usePersonalAccount = () => {
    const user = useOptionalAuthUser();
    const { getPersonalAccount } = useAccountsRepository();

    return useQuery(
        [personalAccountKey, user?.email],
        async () => {
            if (!user?.email) {
                return undefined;
            }
            return getPersonalAccount(user.email);
        },
        {
            staleTime: 10000,
        },
    );
};

export const useUpdateContactEmail = () => {
    const { updateAccount } = useAccountsRepository();

    const client = useQueryClient();
    const { pushSuccessNotification, pushApiErrorNotification } = useNotifications();

    return useMutation(updateAccount, {
        onMutate: () => {
            sendChangeContactEmail('Start');
        },
        onSuccess: async () => {
            sendChangeContactEmail('Success');
            await client.invalidateQueries([personalAccountKey]);
            pushSuccessNotification('Contact email was updated.');
        },
        onError: () => {
            sendChangeContactEmail('Error');
            pushApiErrorNotification('Your contact email could not be updated.');
        },
    });
};

export const useUpdateAccountName = () => {
    const { updateAccount } = useAccountsRepository();

    const client = useQueryClient();
    const { pushSuccessNotification, pushApiErrorNotification } = useNotifications();

    return useMutation(updateAccount, {
        onMutate: () => {
            sendChangeAccountName('Start');
        },
        onSuccess: async () => {
            sendChangeAccountName('Success');
            await client.invalidateQueries([personalAccountKey]);
            pushSuccessNotification('Account name was updated.');
        },
        onError: () => {
            sendChangeAccountName('Error');
            pushApiErrorNotification('Your account name could not be updated.');
        },
    });
};
